module.exports = __webpack_public_path__ + "img/group.34ccfb9c.png";